var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"epic-list-item-container"},_vm._l((_vm.children),function(child){return _c('epic-item',{key:_vm.generateKey(child),attrs:{"epic":child,"epics-have-children":_vm.epicsHaveChildren,"client-width":_vm.clientWidth,"child-level":_vm.childLevel}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }